import React from 'react'
import { NavLink as RouterNavLink, useNavigate } from 'react-router-dom'
import { AppShell, NavLink, Text, Button, Divider } from '@mantine/core'
import { LayoutList, LogOut } from 'lucide-react'
import { useAuth } from '../AuthContext'

export default function AdminLayout({ children }) {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/admin/login', { replace: true })
  }

  return (
    <AppShell navbar={{ width: 220, breakpoint: 'sm' }} padding="md" h="100vh">
      <AppShell.Navbar p="md" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Text fw={700} size="lg" mb="xl" mt="xs">
          Moscow Garage
        </Text>

        <NavLink
          component={RouterNavLink}
          to="/admin/services"
          label="Услуги"
          leftSection={<LayoutList size={16} />}
          style={({ isActive }) => ({ borderRadius: 8, fontWeight: isActive ? 600 : 400 })}
        />

        <Divider mt="auto" mb="md" />
        <Button
          variant="subtle"
          color="gray"
          leftSection={<LogOut size={16} />}
          onClick={handleLogout}
          justify="start"
          fullWidth
        >
          Выйти
        </Button>
      </AppShell.Navbar>

      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  )
}
